import React from 'react';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';

import NoteNewForm from 'components/forms/clients/NoteNewForm';

class NoteNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shown: false,
    };
  }

  onShow = () => {
    this.setState({ shown: true });
  };

  onExit = () => {
    this.setState({ shown: false });
  };

  render() {
    const { intl, show, close, onSubmitParent, client } = this.props;
    const { shown } = this.state;
    const messages = intl.messages;

    return (
      <Modal show={show} onHide={close} bsSize="lg" onExit={this.onExit} onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_note}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NoteNewForm shown={shown} client={client} onSubmitParent={onSubmitParent} />
        </Modal.Body>
      </Modal>
    );
  }
}

export default injectIntl(NoteNew);
